import beatriceLogo from "../../assets/images/beatriceLogo.png";
import useHomeStore from "../../store/homeStore";
import useUserContextStore from "../../store/userContextStore";
import { SecurityQuestionCheck } from "./SecurityQuestionCheck";
import { useEffect, useState,useMemo } from "react";

const Header = () => {
  const homePageLinks = useHomeStore((state)=> state.HomePageLinks);
  const globalUserContext = useUserContextStore((state) => state.context);
  const [context, setContext] = useState(null);

  useEffect(()=>{
      if(globalUserContext){
        setContext(globalUserContext)
      }
    },[globalUserContext])

    useEffect(()=>{
      if(window.location.pathname.includes('UserProfile')){
        setContext(null)
      }
    },[window])


  return (
    <header className="new-head">
      <nav className="navbar navbar-default">
        <div className="container-fluid">

          <div className="navbar-header">
            <a
              style={{ marginLeft: "5px" }}
              className="navbar-brand"
              href={homePageLinks?.clientLink || "/"}
            >
              <img src={beatriceLogo} className="logo-icon" alt="logo" />
            </a>
          </div>

          <div className="collapse navbar-collapse">
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a target="_blank" href={homePageLinks?.aboutLink || "/"} rel="noreferrer">
                  About
                </a>
              </li>
              <li>
                <a target="_blank" href={homePageLinks?.servicesLink || "/"} rel="noreferrer">
                  Services
                </a>
              </li>
              <li>
                <a target="_blank" href={homePageLinks?.newsLink || "/"} rel="noreferrer">
                  News
                </a>
              </li>
              <li>
                <a target="_blank" href={homePageLinks?.contactLink || "/"} rel="noreferrer">
                  Contact Us
                </a>
              </li>
              <li>
                <a id="nav-Login" style={{ color: "#dae100" }} href="/">
                  Login
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Floating Star */}
        <div
          style={{
            position: "relative",
            right: 0,
            width: "50px",
            left: "95%",
            marginTop: "8px",
          }}
        >
          <div
            className="icon-floating-star"
            style={{
              animation: "scaleChange 3s infinite",
              transition: "transform 0.5s",
            }}
          >
            <svg viewBox="0 0 71 80" fill="none">
              <path
                d="M71 39.8388C70.6357 39.979 70.1873 40.2032 69.7108 40.2592C52.5037 46.6488 38.2952 60.7172 35.8291 79.7179C33.419 60.7172 19.2105 46.6488 1.89127 40.2592C1.49893 40.2032 0.994498 39.979 0.658203 39.8388C0.994498 39.6987 1.49893 39.5025 1.89127 39.3624C19.1825 33.0849 33.419 18.9605 35.8291 0.0158691C38.2952 18.9605 52.5037 33.0849 69.7108 39.3624C70.1873 39.5025 70.6076 39.6987 71 39.8388Z"
                fill="#DAE100"
              />
            </svg>

          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
